import { darken } from 'polished';
import styled, { css } from 'styled-components';

import {
  A,
  Button,
  FocusButton,
  standardFocusStyles,
} from '@main/pc-core-components';
import { RequestPreviewWrapper } from '@main/privacy-center/src/containers/RequestPreview/wrappers';
import { sp, timing } from '@main/theme';

/**
 * More wrapper for spacing the button properly
 */
export const MoreWrapper = styled(RequestPreviewWrapper)`
  margin: 0 auto;
`;

/**
 * The Mobile notification Wrapper
 */
const mobileIconStyles = css`
  border: none;
  border-radius: 50%;
  font-weight: 600;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: ${timing.shortEase('background-color', 'color')};
`;

export const NotificationCountWrapper = styled.div`
  ${mobileIconStyles}

  color: ${({ theme }) => theme.colors.textOnPrimary};
  background-color: ${({ theme }) => theme.colors.primary};
  height: ${sp(3)};
  width: ${sp(3)};

  &:hover {
    background-color: ${({ theme }) => darken(0.05, theme.colors.primary)};
  }
`;

export const MobileBellIconWrapper = styled.div`
  ${mobileIconStyles}

  color: ${({ theme }) => theme.colors.primary};
  background-color: ${({ theme }) => theme.colors.white};
  height: ${sp(5)};
  width: ${sp(5)};

  &:hover {
    background-color: ${({ theme }) => darken(0.03, theme.colors.white)};
  }
`;

/**
 * The notification button
 */
export const StyledButton = styled(Button)`
  display: inline;
`;

/**
 * The requests list wrapper
 */
export const RequestsWrapper = styled.ul`
  overflow-y: auto;
  max-height: 400px;
  list-style: none;
  padding: 0;
  max-width: ${sp(40)};
  margin: 0;
`;

/**
 * Styled A component for tabbing focus
 */
export const StyledA = styled(A)`
  font-family: '${({ theme }) => theme.textStyles.fontFamilyHeader.name}';

  &:focus {
    ${standardFocusStyles}
  }
`;

/**
 * The popover list footer wrapper for show more link
 */
export const FooterWrapper = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.transcendNavy4};
  margin: 0;
  padding: ${sp(1)} ${sp(0.1)} 0 0;
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 2;
  box-shadow: 0 -18px 13px white;
`;

/**
 * The show more or less text wrapper
 */
export const ShowWrapper = styled(FocusButton)`
  color: ${({ theme }) => theme.colors.secondary};
  font-size: ${sp(1.75)};
  border-radius: ${sp(0.5)};
  font-weight: 600;
  padding: 0;
  margin: 0;
  font-family: '${({ theme }) => theme.textStyles.fontFamilyHeader.name}';

  &:hover {
    opacity: 0.8;
  }
`;
